import React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import { withStyles } from '@material-ui/core';

const styles = {
  container: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center'
  }
};

export const LoadingIndicator = ({classes, ...props}) => <div className={classes.container}> <CircularProgress {...props}/> </div>

export default withStyles(styles)(LoadingIndicator);
